<!--
  Sub-modale "Riepilogo corriere" — sub-step di confirm-shipment (v2.11.0 J.4.b).
  Diakonix native modal pattern (z-index 2200, nested sopra confirm-shipment 2100).
  Cross-use con controllo-quality (v2.13.0 future).
-->
@if (isCourOn) {
  <div class="cc-backdrop" (click)="close()">
    <div
      class="cc-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cc-title"
      (click)="$event.stopPropagation()"
    >
      <header class="cc-header">
        <h2 id="cc-title">📋 Riepilogo dati ordine</h2>
        <button
          type="button"
          class="cc-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <div class="cc-body">
        @if (loading) {
          <div class="cc-loading">
            <i class="bx bx-loader-alt bx-spin"></i>
            Caricamento...
          </div>
        } @else if (order) {
          <dl class="cc-summary">
            @if (order.or_order_number) {
              <div class="cc-summary-row">
                <dt>N° ordine</dt>
                <dd><strong>{{ order.or_order_number }}</strong></dd>
              </div>
            }
            @if (order.or_shipping_customer) {
              <div class="cc-summary-row">
                <dt>Cliente</dt>
                <dd>{{ order.or_shipping_customer }}</dd>
              </div>
            }
            <div class="cc-summary-row">
              <dt>Indirizzo</dt>
              <dd>{{ order.or_shipping_address || '—' }}</dd>
            </div>
            <div class="cc-summary-row">
              <dt>Città</dt>
              <dd>
                {{ order.or_shipping_zip || '—' }}
                {{ order.or_shipping_city || '' }}
                @if (order.or_shipping_prov) { ({{ order.or_shipping_prov }}) }
              </dd>
            </div>
            <div class="cc-summary-row">
              <dt>Nazione</dt>
              <dd>{{ order.or_shipping_country || '—' }}</dd>
            </div>
            <div class="cc-summary-row">
              <dt>Corriere</dt>
              <dd>
                {{
                  order.vs_details?.carrier_desc
                  || order.vs_details?.carrier_other
                  || '—'
                }}
              </dd>
            </div>
          </dl>

          @if (correctAddress) {
            <span class="cc-badge cc-badge--ok">
              <i class="bx bx-check-circle"></i> Indirizzo completo
            </span>
          } @else {
            <span class="cc-badge cc-badge--warn">
              <i class="bx bx-info-circle"></i> Indirizzo incompleto
            </span>
          }
        }
      </div>

      <footer class="cc-footer">
        <button
          type="button"
          class="cc-btn cc-btn--change"
          (click)="changeCarrier()"
        >
          <i class="bx bx-refresh"></i>
          Aggiorna corriere
        </button>
        <button
          type="button"
          class="cc-btn cc-btn--close"
          (click)="close()"
        >
          <i class="bx bx-check"></i>
          Chiudi
        </button>
      </footer>
    </div>
  </div>
}
